// Angular
import { Injectable, OnDestroy, OnInit } from '@angular/core';

// Libraries
import { BehaviorSubject } from 'rxjs';
import { Observable, Subscriber } from 'rxjs';
import * as XLSX from 'xlsx';

// Models
import { AppCleanup } from '../models';

@Injectable({
	providedIn: 'root',
})
export class GlobalService extends AppCleanup implements OnInit, OnDestroy {
	isPublic: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	tenantNameFull: BehaviorSubject<string> = new BehaviorSubject<string>('');
	tenantNameShort: BehaviorSubject<string> = new BehaviorSubject<string>('');
	isMobile: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	ngOnInit() {}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	csvToArray(csvFile): Observable<any> {
		let arrayBuffer;
		let fileReader = new FileReader();
		fileReader.readAsArrayBuffer(csvFile);

		return Observable.create((observer: Subscriber<any[]>) => {
			// if success
			fileReader.onload = (ev: ProgressEvent) => {
				arrayBuffer = fileReader.result;
				let data = new Uint8Array(arrayBuffer);
				let array = new Array();

				for (let i = 0; i != data.length; ++i) {
					array[i] = String.fromCharCode(data[i]);
				}

				let bstr = array.join('');
				let workbook = XLSX.read(bstr, { type: 'binary', sheetStubs: true });
				let first_sheet_name = workbook.SheetNames[0];
				let worksheet = workbook.Sheets[first_sheet_name];
				let jsonArray: any[][] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
				observer.next(jsonArray);
				observer.complete();
			};

			// if failed
			fileReader.onerror = (error) => {
				observer.error(error);
			};
		});
	}
}
